import React, { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { settings } from './../settings'
import ArtworldContext from './../context/ArtworldContext'
import { forEach, isEmpty, includes } from 'lodash'

// Components
import SearchInput from './SearchInput'
import SearchCategories from './SearchCategories'
import AdvancedSearch from './AdvancedSearch'
import Sponsors from './Sponsors'
import SearchInfoText from './SearchInfoText'

// React Google Analytics Module
import ReactGA from 'react-ga';
ReactGA.initialize(settings.googleAnalytics);

const Search = (props) => {

  const context = useContext(ArtworldContext)

  let navigate = useNavigate();

  const [queryString, setQueryString] = useState('')
  const [showAdvancedSearchOnMobile, setShowAdvancedSearchOnMobile] = useState(false)

  const sidebarClasses = !isEmpty(props.sidebarClasses)
    ? props.sidebarClasses.join(' ')
    : 'active';


  /**
   * Fetch filters
   */
  async function fetchFilters() {

    return await context.getFilters()
      .then(res => {
        context.updateGlobalState('advancedSearchFilters', res)
        return res
      })
      .catch(err => console.warn(err));
  }

  /**
   * Run useEffect
   * with a small deplay so the first call can finish to prevent multiple API calls
   */
  useEffect(() => {
    setTimeout(function () {
      fetchFilters()
    }, 200)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {

    // Get current filters
    let currentFilters = { ...context.advancedSearch };

    // Clone queryStrings
    let queryStrings = { ...props.queryStrings }

    // Remove page setting
    delete queryStrings.page

    if (!isEmpty(queryStrings)) {
      forEach(queryStrings, function (value, key) {
        currentFilters[key] = value
      });
    }

    // Check URL for categories
    if (props && props.matchSearch) {
      if (!isEmpty(props.matchSearch.params.q)) {
        const categories = Object.keys(context.categories)

        const q = includes(props.matchSearch.params.q, '+') ? props.matchSearch.params.q.split('+') : [props.matchSearch.params.q]

        let c = false

        const chosenCategories = q.map(a => {
          if (includes(categories, a)) {
            c = true
            return a
          }

          return ''
        })

        if (!c) {
          setQueryString(props.matchSearch.params.q)
        }
        else {
          currentFilters['types'] = chosenCategories
        }
      }
    }

    if (currentFilters && JSON.stringify(currentFilters) !== '{"keyword":"","page":1}') {
      // Push new currentFilters to global state and fire a makeApiCall
      context.updateAdvancedSearchWithArray(currentFilters)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  useEffect(() => {

    const newUrl = context.createCurrentURL()

    const currentUrl = window.location.pathname + (window.location.search ? window.location.search : '')

    if (newUrl && currentUrl !== newUrl) {

      // Push URL to custom browser history array
      context.setLocation(newUrl)

      navigate(newUrl);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.advancedSearch, window.location.pathname])


  const advancedSearchOnMobile = showAdvancedSearchOnMobile ? <AdvancedSearch /> : ''


  return (
    <div className={sidebarClasses} id="search">

      <div className="topPart">

        <SearchInput queryString={queryString} />

        <SearchCategories />

        {props.source && props.source !== 'header' ? <AdvancedSearch /> : (
          <div className="show-results-button">
            <button className="button is-success is-fullwidth" onClick={() => setShowAdvancedSearchOnMobile(showAdvancedSearchOnMobile ? false : true)}>Show advanced search</button>
          </div>
        )}

        {advancedSearchOnMobile}

        {props.source && props.source === 'header' ? (
          <div className="show-results-button">
            <button className="button is-success is-medium is-fullwidth" onClick={() => props.toggleHeader()}>Show results ({context.searchresults.total})</button>
            {/* <button className="button is-success is-medium is-fullwidth">Show results ({context.searchresults.total})</button> */}
          </div>
        ) : ''}

        < div className="search-info-text">
          <SearchInfoText />
        </div>

      </div>

      <div className="bottonPart">
        <Sponsors />
      </div>

    </div >
  );
};

export default Search;
